module.exports = __webpack_public_path__ + "fonts/iconfont.ba49e242.woff";